import { ViewConfig } from "datasheets/model/core/Workbook";

export const viewType = "record";

export interface AutoformViewConfig extends ViewConfig {
  datasetId?: string;
}
